const windowForServer = {
    document: { cookie: '' },
    innerWidth: 0,
    location: {},
    navigator: {
        userAgent: ''
    }
};

export const setLocationForServer = (protocol, host, pathname) => {
    windowForServer.location = new URL(`${protocol}://${host}${pathname}`);
};

export const setUserAgentForServer = userAgent => {
    windowForServer.navigator.userAgent = userAgent;
};

export const setCookieForServer = cookie => {
    windowForServer.document.cookie = cookie;
};

export const getWindow = () => {
    if (typeof window !== 'undefined') {
        return window;
    }
    return windowForServer;
};
